import api from './api';

// Get inventories for ordering selector
export const getInventoriesForOrdering = async (storeId) => {
  const response = await api.get('/orders/inventories', {
    params: { storeId }
  });
  return response.data;
};

// Calculate order suggestions based on selected inventory
export const calculateOrderSuggestions = async (data) => {
  const response = await api.post('/orders/calculate', data);
  return response.data;
};

// Create a new order
export const createOrder = async (orderData) => {
  const response = await api.post('/orders', orderData);
  return response.data;
};

// Get all orders
export const getAllOrders = async (storeId, status) => {
  const response = await api.get('/orders', {
    params: { storeId, status }
  });
  return response.data;
};

// Get order by ID
export const getOrderById = async (orderId) => {
  const response = await api.get(`/orders/${orderId}`);
  return response.data;
};

// Send order email to vendor
export const sendOrderEmail = async (orderId, emailConfig) => {
  const response = await api.post(`/orders/${orderId}/send-email`, emailConfig);
  return response.data;
};